export default __webpack_public_path__ + "static/41-8a7f826b805e6c43d55d44c9a9496e67.png";